import commonService from './commonService'
import utils from './utils'

const getAll = async () => {
  const url = utils.url + '/countries'
  return await commonService.load(url, null, [])
}

const get = async (id) => {
  const url = `${utils.url}/countries/${id}`
  return await commonService.load(url)
}

export default { getAll, get }
